import CloseIcon from '@mui/icons-material/Close';
import { Box } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import React, { useContext} from 'react';
import { useLocation } from 'react-router-dom';
import useWebContext from '../../hooks/useWebContext';
import { LocationHistoryContext } from '../../provider/LocationHistoryProvider';
import { NotifyContext } from '../../provider/NotifyContextProvider';
import { MyMButton } from '../../ui-elements/MyMButton';
import { MyMImage } from '../../ui-elements/MyMImage';
import { MyMLabel, MyMVariantLabel } from '../../ui-elements/MyMLabel';

/** MyMine Version3.0 新規追加
* Home Survey Reminder
*/
export const HomeSurveyReminder = React.memo(({ screenId }) => {

  const { controlSettings, screenSettings } = useWebContext(screenId);
  const { notify } = useContext(NotifyContext);
  const [open, setOpen] = React.useState(true);
  const location = useLocation();

  const prevUrl = useContext(LocationHistoryContext);

  /** Provide Feedback押下イベント */
  const onClickProvideFeedback = () => {
    // Snackbarを閉じる
    setOpen(false);
    setTimeout(() => {
    window.open(
      `${process.env.PUBLIC_URL}/MyM801?surveyId=${notify.SurveyNotify.SurveyId}`,
      '_blank'
      );
    }, 100);
  }
  

  // StepPageからの遷移以外はReminder非表示（StepPage遷移でもシェアリンク経由時は非表示）
  if (prevUrl?.current?.endsWith('MyM703') !== true || location.state?.previewFileId) {
    return <></>;
  }

  // Survey回答期間中 且つ 未回答の時のみReminder表示
  return notify?.SurveyNotify?.IsCurrentSurvey && notify?.SurveyNotify?.IsAnswered === false
    ? <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      sx={{
        bottom: { md: '65px !important' },
        '.MuiPaper-root': {
          backgroundColor: 'rgb(177 171 171 / 91%)',
          color: 'black',
          opacity: '0.9 !important',
          padding: '15px 35px 20px',
          minWidth: 'auto',
          display: 'flex',
          justifyContent: 'center',
          '.MuiSnackbarContent-message': { textAlign: 'center' },
          '.MuiSnackbarContent-action': { margin: 0, padding: 0 }
        }
      }}
      autoHideDuration={screenSettings.SurveyReminderTimeoutSeconds * 1000}
      open={open}
     
      onClose={(event, reason) => {
        if (reason === 'clickaway') {
          // 外部クリック（clickaway）のときは無視して閉じない
          return;
        }
        setOpen(false);
      }}
      message={
        <Box>
          <Box className='d-flex justify-content-center mx-5'><MyMVariantLabel variant='h6' sx={{ textAlign: 'left', width: 'fit-content' }}>{controlSettings.LabelList.lblReminder}</MyMVariantLabel></Box>

          <MyMButton onClick={onClickProvideFeedback} sx={{ height: 33, width: '100%', marginTop: 2, backgroundColor: '#ED7D31 !important' }} >
            <MyMImage height='30px' width='30px' sx={{ height: 30, marginBottom: 7 }} screenId={screenId} filePath={controlSettings.ImageList.imgReminder} />
            <MyMLabel className='ms-2 mt-1' sx={{ color: 'white' }} >{controlSettings.LabelList.btnProvideFeedback}</MyMLabel>
          </MyMButton >

        </Box>}
      action={
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          sx={{ position: 'absolute', right: 10, top: 5, backgroundColor: '#e5e5e5', width: 25, height: 25, }}
          onClick={() => setOpen(false)}
        >
          <CloseIcon fontSize="small" />
        </IconButton>}
    />
    : <></>;
})
